export default __webpack_public_path__ + "static/media/time-icon.2ad9eec7.svg";